import React from 'react';
import { createPortal } from 'react-dom';
import useScrollLock from '../../utils/useScrollLock';
import './LayerOverlay.css';

/* MECANISMO BASE de capas con fondo opaco (regla de raíz, Miguel 2026-07-23):
   "si oscureces el fondo, lo congelas". El scroll lock NO se aplica componente
   por componente — vive AQUÍ: toda capa presente o futura que use LayerOverlay
   bloquea el fondo automáticamente y restaura la posición exacta al cerrar,
   sin que nadie tenga que acordarse. ConfirmDialog y el EntityInspector
   (drawer) se montan sobre esto. Un popover SIN fondo opaco (OverflowMenu,
   calendario) no usa LayerOverlay y no bloquea. */
export default function LayerOverlay({
  open = true,
  className = '',        // clase de layout del caller (centrado, a la derecha…)
  onBackdrop = null,     // click en el fondo (fuera del contenido)
  children,
}) {
  useScrollLock(open);
  if (!open) return null;
  return createPortal(
    <div
      className={`ui-layer-overlay${className ? ` ${className}` : ''}`}
      onMouseDown={(e) => { if (e.target === e.currentTarget) onBackdrop?.(); }}
    >
      {children}
    </div>,
    document.body
  );
}
